import { render, staticRenderFns } from "./block-tranzzo-generate-token.vue?vue&type=template&id=e412a342&scoped=true&lang=pug"
import script from "./block-tranzzo-generate-token.vue?vue&type=script&lang=js"
export * from "./block-tranzzo-generate-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e412a342",
  null
  
)

export default component.exports